import { render } from "./WalletTopUpSelection.vue?vue&type=template&id=5a592712&scoped=true"
import script from "./WalletTopUpSelection.vue?vue&type=script&lang=ts"
export * from "./WalletTopUpSelection.vue?vue&type=script&lang=ts"

import "./WalletTopUpSelection.vue?vue&type=style&index=0&id=5a592712&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a592712"

export default script